import React from 'react';
import Tooltip from '@prisjakt/ui-tooltip-new';

type OwnProps = {
  icon: React.ReactElement;
  showTooltip?: boolean;
  tooltipText?: string;
};

const Icon = ({ icon, showTooltip = false, tooltipText }: OwnProps) => {
  return (
    <>
      {showTooltip ? (
        <Tooltip placement="top" title={tooltipText} renderOnMouseOver>
          {icon}
        </Tooltip>
      ) : (
        icon
      )}
    </>
  );
};

export default Icon;
